import React from 'react'
import { useIntl } from 'react-intl'
import ReactPaginate from 'react-paginate'
import { useEffect, useState } from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../../../_metronic/helpers'
import SharedFilesRow from './SharedFilesRow'
import DeviceOnMap from '../../file-area/components/DeviceOnMap'
import clsx from 'clsx'
import SVG from 'react-inlinesvg'

interface InputProps {
  fileList: any
  paginationInfo: any
  currentPage: number
  setCurrentPage: any
  itemsPerPage: number
  setItemsPerPage: any
  setListView: any
  listView: any
}

const SharedFilesTable: React.FC<InputProps> = ({
  fileList,
  paginationInfo,
  currentPage,
  setCurrentPage,
  itemsPerPage,
  setItemsPerPage,
  setListView,
  listView,
}) => {
  const [loading, setLoading] = useState<boolean>(false)
  const [currentItems, setCurrentItems] = useState<any>([])
  const [show, setShow] = useState<boolean>(false)
  const [location, setLocation] = useState<any>(null)
  const [sorting, setSorting] = useState<{ col: string | null; order: 'asc' | 'desc' }>({
    col: null,
    order: 'asc',
  })
  const intl = useIntl()

  const columns = [
    { field: 'index', label: '', sortable: false },
    { field: 'title', label: 'DEVICE.VEHICLE_NO', sortable: true },
    { field: 'startEpoch', label: 'GENERAL.LABEL.DATE_AND_TIME', sortable: true },
    { field: 'duration', label: 'INPUT.LABEL.DURATION', sortable: true },
    { field: 'fileType', label: 'GENERAL.LABEL.FILE_TYPE', sortable: false },
    { field: 'position', label: 'GENERAL.LABEL.POSITION', sortable: false },
    { field: 'deviceId', label: 'DEVICE.DEVICE_NO', sortable: true },
    { field: 'type', label: 'GENERAL.LABEL.TYPE', sortable: false },
    { field: 'active', label: 'GENERAL.LABEL.ACTIVE', sortable: false },
    { field: 'downloadable', label: 'GENERAL.LABEL.DOWNLOADABLE', sortable: false },
  ]

  useEffect(() => {
    if (fileList && fileList.length > 0) {
      setItemsOnPage(sorting.col, sorting.order)
    } else {
      setCurrentItems([])
    }
  }, [fileList, itemsPerPage, sorting.col, sorting.order])

  const extractVehicleNo = (title: string = '') => {
    const match = title.match(/vehicle:\s*(.*)$/i)
    return match ? match[1].trim() : ''
  }

  const setItemsOnPage = (column: string | null, order: 'asc' | 'desc' | null) => {
    const data = [...fileList]

    if (column) {
      data.sort((a: any, b: any) => {
        const aFile = a.file;
        const bFile = b.file;

        if (column === 'duration') {
          const getDuration = (item: any) => {
            if (!item.startEpoch || !item.endEpoch) return null
            return item.endEpoch - item.startEpoch
          }
          const aVal = getDuration(aFile)
          const bVal = getDuration(bFile)

          const aMissing = aVal == null
          const bMissing = bVal == null

          if (aMissing && bMissing) return 0
          if (aMissing) return 1
          if (bMissing) return -1

          return order === 'asc' ? Number(aVal) - Number(bVal) : Number(bVal) - Number(aVal)
        }
        if (['deviceId', 'startEpoch', 'title'].includes(column)) {
          let aStr = ''
          let bStr = ''

          if (column === 'title') {
            aStr = extractVehicleNo(aFile?.title).toLowerCase()
            bStr = extractVehicleNo(bFile?.title).toLowerCase()
          } else {
            aStr = aFile && aFile[column] ? aFile[column]?.toString().toLowerCase() : ''
            bStr = bFile && bFile[column] ? bFile[column]?.toString().toLowerCase() : ''
          }

          return order === 'asc' ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr)
        }
        return 0
      })
    }

    setCurrentItems(data)
  }

  const handlePageClick = (event: any) => {
    setCurrentPage(event.selected + 1)
  }

  const handleOrder = (columnDef: any) => {
    if (!columnDef.sortable) return

    setLoading(true)
    const column = columnDef.field
    let order: 'asc' | 'desc' = 'asc'

    if (sorting.col === column && sorting.order === 'asc') {
      order = 'desc'
    }

    setSorting({ col: column, order })
    setItemsOnPage(column, order)

    setTimeout(() => {
      setLoading(false)
    }, 100)
  }

  return (
    <div className='card-body py-3 file-table'>
      <div className='table-responsive max-height-49vh'>
        <table
          className={`table align-middle table-row-bordered fs-6 gy-5 dataTable no-footer ${listView === 'compact' ? 'compact' : 'default'
            }`}
        >
          <thead className='sticky-header'>
            <tr className='text-muted'>
              {columns.map((column: any, i: any) => {
                return (
                  <th
                    key={i}
                    className={`text-gray-600 ${column.field === 'index' ? 'th-index' : ''} 
                    ${column.field === 'title' ? 'file-title' : ''}
                    ${column.field === 'action' ? 'd-flex justify-content-end' : ''}`}
                  >
                    <div
                      onClick={() => handleOrder(column)}
                      className={column.sortable ? 'sortable d-flex' : ''}
                    >
                      {column.label && intl.formatMessage({ id: column.label })}
                      {sorting && sorting.col === column.field ? (
                        <>
                          {sorting.order === 'asc' && (
                            <KTSVG
                              path='/media/icons/duotone/Navigation/Angle-up.svg'
                              className='svg-icon-2'
                            />
                          )}
                          {sorting.order === 'desc' && (
                            <KTSVG
                              path='/media/icons/duotone/Navigation/Angle-down.svg'
                              className='svg-icon-2'
                            />
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </th>
                )
              })}
            </tr>
          </thead>
          <tbody className='text-gray-600'>
            {currentItems.length > 0 ? (
              currentItems.map((sharedFile: any, i: number) => (
                <React.Fragment key={i}>
                  <SharedFilesRow
                    sharedFile={sharedFile}
                    setShow={setShow}
                    setLocation={setLocation}
                    index={(currentPage - 1) * itemsPerPage + i}
                  />
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td colSpan={9}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    {intl.formatMessage({ id: 'TOAST.THERE_ARE_NO_SHARED_FILES' })}
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className='row pt-3 border-top' style={{ marginTop: '32px' }}>
        <div className='pagination-section'>
          <div className='d-flex align-items-center justify-content-between'>
            {currentItems.length > 0 && !loading && (
              <div id='kt_table_users_paginate'>
                <ReactPaginate
                  className='pagination'
                  breakLabel='...'
                  nextLabel={paginationInfo?.totalPages > 1 ? <>Next &raquo;</> : null}
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={5}
                  pageCount={paginationInfo?.totalPages || 0}
                  pageClassName='page-item'
                  previousLinkClassName='page-link'
                  previousClassName='page-item'
                  nextClassName='page-item'
                  nextLinkClassName='page-link'
                  previousLabel={<>&laquo; Previous</>}
                  activeClassName='active'
                  pageLinkClassName='page-link'
                  forcePage={currentPage - 1}
                />
              </div>
            )}
            {currentItems.length > 0 && !loading && (
              <div className='d-flex align-items-center position-relative view-mode'>
                <div
                  className={clsx('btn btn-icon btn-active-light-primary', {
                    active: listView === 'default',
                  })}
                  onClick={(e) => {
                    setListView('default')
                    setItemsPerPage(100)
                    setCurrentPage(1)
                  }}
                >
                  <span className='svg-icon svg-icon-2 svg-icon-lg-1'>
                    <SVG src={toAbsoluteUrl('/media/icons/duotone/Text/Menu.svg')} />
                  </span>
                </div>
                <div
                  className={clsx('btn btn-icon btn-active-light-primary', {
                    active: listView === 'compact',
                  })}
                  onClick={(e) => {
                    setListView('compact')
                    setItemsPerPage(100)
                    setCurrentPage(1)
                  }}
                >
                  <span className='svg-icon svg-icon-2 svg-icon-lg-1'>
                    <SVG src={toAbsoluteUrl('/media/icons/duotone/Text/Align-justify.svg')} />
                  </span>
                </div>

                <ul className='pagination ml-8'>
                  {[25, 50, 100].map((size) => (
                    <li key={size} className={clsx('page-item', { active: itemsPerPage == size })}>
                      <button
                        type='button'
                        className='page-link'
                        aria-label={size.toString()}
                        onClick={(e) => {
                          setItemsPerPage(size)
                          setCurrentPage(1)
                        }}
                      >
                        {size}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
      {show && (
        <DeviceOnMap show={show} location={location} setLocation={setLocation} setShow={setShow} />
      )}
    </div>
  )
}

export default SharedFilesTable
